import { http } from '@/core/helpers/http.helper';
import { CommunicationLanguage } from './communication-language.interface';

export interface CommunicationLanguageServiceInterface {
   getCommunicationLanguages(): Promise<Array<CommunicationLanguage>>;
}

export class CommunicationLanguageService implements CommunicationLanguageServiceInterface {
   async getCommunicationLanguages(): Promise<CommunicationLanguage[]> {
      return await http
         .get<Array<CommunicationLanguage>>(`/languages`, { params: { 'filter[is_communication_language]': 1 } })
         .then((response) => response.data);
   }
}
